// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.noOutline {
  outline: none !important;
}
.wcagOutline:focus {
  outline: 1px dashed #595959 !important;
  outline-offset: 2px !important;
  transition: none !important;
}
button#nebula_div_btn {
  height: auto !important;
}
.kampyle_vertical_button {
  background-color: transparent !important;
  font-family: "Open Sans", sans-serif;
  cursor: pointer;
  position: fixed;
  top: 45%;
  z-index: 99999990;
  height: 35px !important;
  min-height: 35px !important;
  max-height: 35px !important;
  width: 125px !important;
  max-width: 125px !important;
  min-width: 125px !important;
  transform: rotate(90deg);
}
.kampyle_vertical_button .kampyle_button {
  height: 35px;
  min-height: 35px !important;
  max-height: 35px !important;
  width: 125px !important;
  min-width: 125px !important;
  max-width: 125px !important;
  background: #c0c0c0;
  color: #000000;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
.kampyle_vertical_button .kampyle_button-text {
  color: #000000;
  font-size: 14px;
  line-height: 35px;
  text-align: center;
  font-weight: normal !important;
}
.kampyle_vertical_button.kampyle_left .kampyle_button {
  border-radius: 3px 3px 0 0;
}
.kampyle_vertical_button.kampyle_right {
  right: -45px;
}
.kampyle_vertical_button.kampyle_left {
  left: -45px;
}
.kampyle_vertical_button.kampyle_right .kampyle_button {
  border-radius: 0 0 3px 3px;
}
.kampyle_vertical_button.kampyle_right,
.kampyle_vertical_button.kampyle_left {
  padding: 0 !important;
}
.kampyle_vertical_button:hover .kampyle_button-text {
  color: #000000;
}
.kampyle_vertical_button:hover .kampyle_button {
  background-color: #c0c0c0;
}
button#nebula_div_btn {
  height: auto !important;
}
.kampyle_vertical_button {
  background-color: transparent !important;
  font-family: "Open Sans", sans-serif;
  cursor: pointer;
  position: fixed;
  top: 45%;
  z-index: 99999990;
  height: 35px !important;
  min-height: 35px !important;
  max-height: 35px !important;
  width: 125px !important;
  max-width: 125px !important;
  min-width: 125px !important;
  transform: rotate(90deg);
}
.kampyle_vertical_button .kampyle_button {
  height: 35px;
  min-height: 35px !important;
  max-height: 35px !important;
  width: 125px !important;
  min-width: 125px !important;
  max-width: 125px !important;
  background: #c0c0c0;
  color: #000000;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
.kampyle_vertical_button .kampyle_button-text {
  color: #000000;
  font-size: 14px;
  line-height: 35px;
  text-align: center;
  font-weight: normal !important;
}
.kampyle_vertical_button.kampyle_left .kampyle_button {
  border-radius: 3px 3px 0 0;
}
.kampyle_vertical_button.kampyle_right {
  right: -45px;
}
.kampyle_vertical_button.kampyle_left {
  left: -45px;
}
.kampyle_vertical_button.kampyle_right .kampyle_button {
  border-radius: 0 0 3px 3px;
}
.kampyle_vertical_button.kampyle_right,
.kampyle_vertical_button.kampyle_left {
  padding: 0 !important;
}
.kampyle_vertical_button:hover .kampyle_button-text {
  color: #000000;
}
.kampyle_vertical_button:hover .kampyle_button {
  background-color: #c0c0c0;
}
button#nebula_div_btn {
  height: auto !important;
}
.kampyle_vertical_button {
  background-color: transparent !important;
  font-family: "Open Sans", sans-serif;
  cursor: pointer;
  position: fixed;
  top: 45%;
  z-index: 99999990;
  height: 35px !important;
  min-height: 35px !important;
  max-height: 35px !important;
  width: 125px !important;
  max-width: 125px !important;
  min-width: 125px !important;
  transform: rotate(90deg);
}
.kampyle_vertical_button .kampyle_button {
  height: 35px;
  min-height: 35px !important;
  max-height: 35px !important;
  width: 125px !important;
  min-width: 125px !important;
  max-width: 125px !important;
  background: #c0c0c0;
  color: #000000;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
.kampyle_vertical_button .kampyle_button-text {
  color: #000000;
  font-size: 14px;
  line-height: 35px;
  text-align: center;
  font-weight: normal !important;
}
.kampyle_vertical_button.kampyle_left .kampyle_button {
  border-radius: 3px 3px 0 0;
}
.kampyle_vertical_button.kampyle_right {
  right: -45px;
}
.kampyle_vertical_button.kampyle_left {
  left: -45px;
}
.kampyle_vertical_button.kampyle_right .kampyle_button {
  border-radius: 0 0 3px 3px;
}
.kampyle_vertical_button.kampyle_right,
.kampyle_vertical_button.kampyle_left {
  padding: 0 !important;
}
.kampyle_vertical_button:hover .kampyle_button-text {
  color: #000000;
}
.kampyle_vertical_button:hover .kampyle_button {
  background-color: #c0c0c0;
}
button#nebula_div_btn {
  height: auto !important;
}
.kampyle_vertical_button {
  background-color: transparent !important;
  font-family: "Open Sans", sans-serif;
  cursor: pointer;
  position: fixed;
  top: 45%;
  z-index: 99999990;
  height: 35px !important;
  min-height: 35px !important;
  max-height: 35px !important;
  width: 125px !important;
  max-width: 125px !important;
  min-width: 125px !important;
  transform: rotate(90deg);
}
.kampyle_vertical_button .kampyle_button {
  height: 35px;
  min-height: 35px !important;
  max-height: 35px !important;
  width: 125px !important;
  min-width: 125px !important;
  max-width: 125px !important;
  background: #c0c0c0;
  color: #000000;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
.kampyle_vertical_button .kampyle_button-text {
  color: #000000;
  font-size: 14px;
  line-height: 35px;
  text-align: center;
  font-weight: normal !important;
}
.kampyle_vertical_button.kampyle_left .kampyle_button {
  border-radius: 3px 3px 0 0;
}
.kampyle_vertical_button.kampyle_right {
  right: -45px;
}
.kampyle_vertical_button.kampyle_left {
  left: -45px;
}
.kampyle_vertical_button.kampyle_right .kampyle_button {
  border-radius: 0 0 3px 3px;
}
.kampyle_vertical_button.kampyle_right,
.kampyle_vertical_button.kampyle_left {
  padding: 0 !important;
}
.kampyle_vertical_button:hover .kampyle_button-text {
  color: #000000;
}
.kampyle_vertical_button:hover .kampyle_button {
  background-color: #c0c0c0;
}
button#nebula_div_btn {
  height: auto !important;
}
.kampyle_vertical_button {
  background-color: transparent !important;
  font-family: "Open Sans", sans-serif;
  cursor: pointer;
  position: fixed;
  top: 45%;
  z-index: 99999990;
  height: 35px !important;
  min-height: 35px !important;
  max-height: 35px !important;
  width: 125px !important;
  max-width: 125px !important;
  min-width: 125px !important;
  transform: rotate(90deg);
}
.kampyle_vertical_button .kampyle_button {
  height: 35px;
  min-height: 35px !important;
  max-height: 35px !important;
  width: 125px !important;
  min-width: 125px !important;
  max-width: 125px !important;
  background: #c0c0c0;
  color: #000000;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
.kampyle_vertical_button .kampyle_button-text {
  color: #000000;
  font-size: 14px;
  line-height: 35px;
  text-align: center;
  font-weight: normal !important;
}
.kampyle_vertical_button.kampyle_left .kampyle_button {
  border-radius: 3px 3px 0 0;
}
.kampyle_vertical_button.kampyle_right {
  right: -45px;
}
.kampyle_vertical_button.kampyle_left {
  left: -45px;
}
.kampyle_vertical_button.kampyle_right .kampyle_button {
  border-radius: 0 0 3px 3px;
}
.kampyle_vertical_button.kampyle_right,
.kampyle_vertical_button.kampyle_left {
  padding: 0 !important;
}
.kampyle_vertical_button:hover .kampyle_button-text {
  color: #000000;
}
.kampyle_vertical_button:hover .kampyle_button {
  background-color: #c0c0c0;
}
button#nebula_div_btn {
  height: auto !important;
}
.kampyle_vertical_button {
  background-color: transparent !important;
  font-family: "Open Sans", sans-serif;
  cursor: pointer;
  position: fixed;
  top: 45%;
  z-index: 99999990;
  height: 35px !important;
  min-height: 35px !important;
  max-height: 35px !important;
  width: 125px !important;
  max-width: 125px !important;
  min-width: 125px !important;
  transform: rotate(90deg);
}
.kampyle_vertical_button .kampyle_button {
  height: 35px;
  min-height: 35px !important;
  max-height: 35px !important;
  width: 125px !important;
  min-width: 125px !important;
  max-width: 125px !important;
  background: #c0c0c0;
  color: #000000;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
.kampyle_vertical_button .kampyle_button-text {
  color: #000000;
  font-size: 14px;
  line-height: 35px;
  text-align: center;
  font-weight: normal !important;
}
.kampyle_vertical_button.kampyle_left .kampyle_button {
  border-radius: 3px 3px 0 0;
}
.kampyle_vertical_button.kampyle_right {
  right: -45px;
}
.kampyle_vertical_button.kampyle_left {
  left: -45px;
}
.kampyle_vertical_button.kampyle_right .kampyle_button {
  border-radius: 0 0 3px 3px;
}
.kampyle_vertical_button.kampyle_right,
.kampyle_vertical_button.kampyle_left {
  padding: 0 !important;
}
.kampyle_vertical_button:hover .kampyle_button-text {
  color: #000000;
}
.kampyle_vertical_button:hover .kampyle_button {
  background-color: #c0c0c0;
}
button#nebula_div_btn {
  height: auto !important;
}
.kampyle_vertical_button {
  background-color: transparent !important;
  font-family: "Open Sans", sans-serif;
  cursor: pointer;
  position: fixed;
  top: 45%;
  z-index: 99999990;
  height: 35px !important;
  min-height: 35px !important;
  max-height: 35px !important;
  width: 125px !important;
  max-width: 125px !important;
  min-width: 125px !important;
  transform: rotate(90deg);
}
.kampyle_vertical_button .kampyle_button {
  height: 35px;
  min-height: 35px !important;
  max-height: 35px !important;
  width: 125px !important;
  min-width: 125px !important;
  max-width: 125px !important;
  background: #c0c0c0;
  color: #000000;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
.kampyle_vertical_button .kampyle_button-text {
  color: #000000;
  font-size: 14px;
  line-height: 35px;
  text-align: center;
  font-weight: normal !important;
}
.kampyle_vertical_button.kampyle_left .kampyle_button {
  border-radius: 3px 3px 0 0;
}
.kampyle_vertical_button.kampyle_right {
  right: -45px;
}
.kampyle_vertical_button.kampyle_left {
  left: -45px;
}
.kampyle_vertical_button.kampyle_right .kampyle_button {
  border-radius: 0 0 3px 3px;
}
.kampyle_vertical_button.kampyle_right,
.kampyle_vertical_button.kampyle_left {
  padding: 0 !important;
}
.kampyle_vertical_button:hover .kampyle_button-text {
  color: #000000;
}
.kampyle_vertical_button:hover .kampyle_button {
  background-color: #c0c0c0;
}
button#nebula_div_btn {
  height: auto !important;
}
.kampyle_vertical_button {
  background-color: transparent !important;
  font-family: "Open Sans", sans-serif;
  cursor: pointer;
  position: fixed;
  top: 45%;
  z-index: 99999990;
  height: 35px !important;
  min-height: 35px !important;
  max-height: 35px !important;
  width: 125px !important;
  max-width: 125px !important;
  min-width: 125px !important;
  transform: rotate(90deg);
}
.kampyle_vertical_button .kampyle_button {
  height: 35px;
  min-height: 35px !important;
  max-height: 35px !important;
  width: 125px !important;
  min-width: 125px !important;
  max-width: 125px !important;
  background: #c0c0c0;
  color: #000000;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
.kampyle_vertical_button .kampyle_button-text {
  color: #000000;
  font-size: 14px;
  line-height: 35px;
  text-align: center;
  font-weight: normal !important;
}
.kampyle_vertical_button.kampyle_left .kampyle_button {
  border-radius: 3px 3px 0 0;
}
.kampyle_vertical_button.kampyle_right {
  right: -45px;
}
.kampyle_vertical_button.kampyle_left {
  left: -45px;
}
.kampyle_vertical_button.kampyle_right .kampyle_button {
  border-radius: 0 0 3px 3px;
}
.kampyle_vertical_button.kampyle_right,
.kampyle_vertical_button.kampyle_left {
  padding: 0 !important;
}
.kampyle_vertical_button:hover .kampyle_button-text {
  color: #000000;
}
.kampyle_vertical_button:hover .kampyle_button {
  background-color: #c0c0c0;
}
button#nebula_div_btn {
  height: auto !important;
}
.kampyle_vertical_button {
  background-color: transparent !important;
  font-family: "Open Sans", sans-serif;
  cursor: pointer;
  position: fixed;
  top: 45%;
  z-index: 99999990;
  height: 35px !important;
  min-height: 35px !important;
  max-height: 35px !important;
  width: 125px !important;
  max-width: 125px !important;
  min-width: 125px !important;
  transform: rotate(90deg);
}
.kampyle_vertical_button .kampyle_button {
  height: 35px;
  min-height: 35px !important;
  max-height: 35px !important;
  width: 125px !important;
  min-width: 125px !important;
  max-width: 125px !important;
  background: #c0c0c0;
  color: #000000;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
.kampyle_vertical_button .kampyle_button-text {
  color: #000000;
  font-size: 14px;
  line-height: 35px;
  text-align: center;
  font-weight: normal !important;
}
.kampyle_vertical_button.kampyle_left .kampyle_button {
  border-radius: 3px 3px 0 0;
}
.kampyle_vertical_button.kampyle_right {
  right: -45px;
}
.kampyle_vertical_button.kampyle_left {
  left: -45px;
}
.kampyle_vertical_button.kampyle_right .kampyle_button {
  border-radius: 0 0 3px 3px;
}
.kampyle_vertical_button.kampyle_right,
.kampyle_vertical_button.kampyle_left {
  padding: 0 !important;
}
.kampyle_vertical_button:hover .kampyle_button-text {
  color: #000000;
}
.kampyle_vertical_button:hover .kampyle_button {
  background-color: #c0c0c0;
}
button#nebula_div_btn {
  height: auto !important;
}
.kampyle_vertical_button {
  background-color: transparent !important;
  font-family: "Open Sans", sans-serif;
  cursor: pointer;
  position: fixed;
  top: 45%;
  z-index: 99999990;
  height: 35px !important;
  min-height: 35px !important;
  max-height: 35px !important;
  width: 125px !important;
  max-width: 125px !important;
  min-width: 125px !important;
  transform: rotate(90deg);
}
.kampyle_vertical_button .kampyle_button {
  height: 35px;
  min-height: 35px !important;
  max-height: 35px !important;
  width: 125px !important;
  min-width: 125px !important;
  max-width: 125px !important;
  background: #c0c0c0;
  color: #000000;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
.kampyle_vertical_button .kampyle_button-text {
  color: #000000;
  font-size: 14px;
  line-height: 35px;
  text-align: center;
  font-weight: normal !important;
}
.kampyle_vertical_button.kampyle_left .kampyle_button {
  border-radius: 3px 3px 0 0;
}
.kampyle_vertical_button.kampyle_right {
  right: -45px;
}
.kampyle_vertical_button.kampyle_left {
  left: -45px;
}
.kampyle_vertical_button.kampyle_right .kampyle_button {
  border-radius: 0 0 3px 3px;
}
.kampyle_vertical_button.kampyle_right,
.kampyle_vertical_button.kampyle_left {
  padding: 0 !important;
}
.kampyle_vertical_button:hover .kampyle_button-text {
  color: #000000;
}
.kampyle_vertical_button:hover .kampyle_button {
  background-color: #c0c0c0;
}
`, "",{"version":3,"sources":["webpack://./src/assets/index_files/inline.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;AACA;EACE,sCAAsC;EACtC,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAG3B,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EAIE,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EAIE,0BAA0B;AAC5B;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAG3B,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EAIE,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EAIE,0BAA0B;AAC5B;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAG3B,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EAIE,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EAIE,0BAA0B;AAC5B;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAG3B,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EAIE,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EAIE,0BAA0B;AAC5B;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAG3B,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EAIE,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EAIE,0BAA0B;AAC5B;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAG3B,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EAIE,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EAIE,0BAA0B;AAC5B;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAG3B,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EAIE,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EAIE,0BAA0B;AAC5B;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAG3B,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EAIE,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EAIE,0BAA0B;AAC5B;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAG3B,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EAIE,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EAIE,0BAA0B;AAC5B;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAG3B,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EAIE,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EAIE,0BAA0B;AAC5B;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B","sourcesContent":[".noOutline {\n  outline: none !important;\n}\n.wcagOutline:focus {\n  outline: 1px dashed #595959 !important;\n  outline-offset: 2px !important;\n  transition: none !important;\n}\nbutton#nebula_div_btn {\n  height: auto !important;\n}\n.kampyle_vertical_button {\n  background-color: transparent !important;\n  font-family: \"Open Sans\", sans-serif;\n  cursor: pointer;\n  position: fixed;\n  top: 45%;\n  z-index: 99999990;\n  height: 35px !important;\n  min-height: 35px !important;\n  max-height: 35px !important;\n  width: 125px !important;\n  max-width: 125px !important;\n  min-width: 125px !important;\n  -ms-transform: rotate(90deg);\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.kampyle_vertical_button .kampyle_button {\n  height: 35px;\n  min-height: 35px !important;\n  max-height: 35px !important;\n  width: 125px !important;\n  min-width: 125px !important;\n  max-width: 125px !important;\n  background: #c0c0c0;\n  color: #000000;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n.kampyle_vertical_button .kampyle_button-text {\n  color: #000000;\n  font-size: 14px;\n  line-height: 35px;\n  text-align: center;\n  font-weight: normal !important;\n}\n.kampyle_vertical_button.kampyle_left .kampyle_button {\n  -webkit-border-radius: 3px 3px 0 0;\n  -moz-border-radius: 3px 3px 0 0;\n  -ms-border-radius: 3px 3px 0 0;\n  border-radius: 3px 3px 0 0;\n}\n.kampyle_vertical_button.kampyle_right {\n  right: -45px;\n}\n.kampyle_vertical_button.kampyle_left {\n  left: -45px;\n}\n.kampyle_vertical_button.kampyle_right .kampyle_button {\n  -webkit-border-radius: 0 0 3px 3px;\n  -moz-border-radius: 0 0 3px 3px;\n  -ms-border-radius: 0 0 3px 3px;\n  border-radius: 0 0 3px 3px;\n}\n.kampyle_vertical_button.kampyle_right,\n.kampyle_vertical_button.kampyle_left {\n  padding: 0 !important;\n}\n.kampyle_vertical_button:hover .kampyle_button-text {\n  color: #000000;\n}\n.kampyle_vertical_button:hover .kampyle_button {\n  background-color: #c0c0c0;\n}\nbutton#nebula_div_btn {\n  height: auto !important;\n}\n.kampyle_vertical_button {\n  background-color: transparent !important;\n  font-family: \"Open Sans\", sans-serif;\n  cursor: pointer;\n  position: fixed;\n  top: 45%;\n  z-index: 99999990;\n  height: 35px !important;\n  min-height: 35px !important;\n  max-height: 35px !important;\n  width: 125px !important;\n  max-width: 125px !important;\n  min-width: 125px !important;\n  -ms-transform: rotate(90deg);\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.kampyle_vertical_button .kampyle_button {\n  height: 35px;\n  min-height: 35px !important;\n  max-height: 35px !important;\n  width: 125px !important;\n  min-width: 125px !important;\n  max-width: 125px !important;\n  background: #c0c0c0;\n  color: #000000;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n.kampyle_vertical_button .kampyle_button-text {\n  color: #000000;\n  font-size: 14px;\n  line-height: 35px;\n  text-align: center;\n  font-weight: normal !important;\n}\n.kampyle_vertical_button.kampyle_left .kampyle_button {\n  -webkit-border-radius: 3px 3px 0 0;\n  -moz-border-radius: 3px 3px 0 0;\n  -ms-border-radius: 3px 3px 0 0;\n  border-radius: 3px 3px 0 0;\n}\n.kampyle_vertical_button.kampyle_right {\n  right: -45px;\n}\n.kampyle_vertical_button.kampyle_left {\n  left: -45px;\n}\n.kampyle_vertical_button.kampyle_right .kampyle_button {\n  -webkit-border-radius: 0 0 3px 3px;\n  -moz-border-radius: 0 0 3px 3px;\n  -ms-border-radius: 0 0 3px 3px;\n  border-radius: 0 0 3px 3px;\n}\n.kampyle_vertical_button.kampyle_right,\n.kampyle_vertical_button.kampyle_left {\n  padding: 0 !important;\n}\n.kampyle_vertical_button:hover .kampyle_button-text {\n  color: #000000;\n}\n.kampyle_vertical_button:hover .kampyle_button {\n  background-color: #c0c0c0;\n}\nbutton#nebula_div_btn {\n  height: auto !important;\n}\n.kampyle_vertical_button {\n  background-color: transparent !important;\n  font-family: \"Open Sans\", sans-serif;\n  cursor: pointer;\n  position: fixed;\n  top: 45%;\n  z-index: 99999990;\n  height: 35px !important;\n  min-height: 35px !important;\n  max-height: 35px !important;\n  width: 125px !important;\n  max-width: 125px !important;\n  min-width: 125px !important;\n  -ms-transform: rotate(90deg);\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.kampyle_vertical_button .kampyle_button {\n  height: 35px;\n  min-height: 35px !important;\n  max-height: 35px !important;\n  width: 125px !important;\n  min-width: 125px !important;\n  max-width: 125px !important;\n  background: #c0c0c0;\n  color: #000000;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n.kampyle_vertical_button .kampyle_button-text {\n  color: #000000;\n  font-size: 14px;\n  line-height: 35px;\n  text-align: center;\n  font-weight: normal !important;\n}\n.kampyle_vertical_button.kampyle_left .kampyle_button {\n  -webkit-border-radius: 3px 3px 0 0;\n  -moz-border-radius: 3px 3px 0 0;\n  -ms-border-radius: 3px 3px 0 0;\n  border-radius: 3px 3px 0 0;\n}\n.kampyle_vertical_button.kampyle_right {\n  right: -45px;\n}\n.kampyle_vertical_button.kampyle_left {\n  left: -45px;\n}\n.kampyle_vertical_button.kampyle_right .kampyle_button {\n  -webkit-border-radius: 0 0 3px 3px;\n  -moz-border-radius: 0 0 3px 3px;\n  -ms-border-radius: 0 0 3px 3px;\n  border-radius: 0 0 3px 3px;\n}\n.kampyle_vertical_button.kampyle_right,\n.kampyle_vertical_button.kampyle_left {\n  padding: 0 !important;\n}\n.kampyle_vertical_button:hover .kampyle_button-text {\n  color: #000000;\n}\n.kampyle_vertical_button:hover .kampyle_button {\n  background-color: #c0c0c0;\n}\nbutton#nebula_div_btn {\n  height: auto !important;\n}\n.kampyle_vertical_button {\n  background-color: transparent !important;\n  font-family: \"Open Sans\", sans-serif;\n  cursor: pointer;\n  position: fixed;\n  top: 45%;\n  z-index: 99999990;\n  height: 35px !important;\n  min-height: 35px !important;\n  max-height: 35px !important;\n  width: 125px !important;\n  max-width: 125px !important;\n  min-width: 125px !important;\n  -ms-transform: rotate(90deg);\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.kampyle_vertical_button .kampyle_button {\n  height: 35px;\n  min-height: 35px !important;\n  max-height: 35px !important;\n  width: 125px !important;\n  min-width: 125px !important;\n  max-width: 125px !important;\n  background: #c0c0c0;\n  color: #000000;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n.kampyle_vertical_button .kampyle_button-text {\n  color: #000000;\n  font-size: 14px;\n  line-height: 35px;\n  text-align: center;\n  font-weight: normal !important;\n}\n.kampyle_vertical_button.kampyle_left .kampyle_button {\n  -webkit-border-radius: 3px 3px 0 0;\n  -moz-border-radius: 3px 3px 0 0;\n  -ms-border-radius: 3px 3px 0 0;\n  border-radius: 3px 3px 0 0;\n}\n.kampyle_vertical_button.kampyle_right {\n  right: -45px;\n}\n.kampyle_vertical_button.kampyle_left {\n  left: -45px;\n}\n.kampyle_vertical_button.kampyle_right .kampyle_button {\n  -webkit-border-radius: 0 0 3px 3px;\n  -moz-border-radius: 0 0 3px 3px;\n  -ms-border-radius: 0 0 3px 3px;\n  border-radius: 0 0 3px 3px;\n}\n.kampyle_vertical_button.kampyle_right,\n.kampyle_vertical_button.kampyle_left {\n  padding: 0 !important;\n}\n.kampyle_vertical_button:hover .kampyle_button-text {\n  color: #000000;\n}\n.kampyle_vertical_button:hover .kampyle_button {\n  background-color: #c0c0c0;\n}\nbutton#nebula_div_btn {\n  height: auto !important;\n}\n.kampyle_vertical_button {\n  background-color: transparent !important;\n  font-family: \"Open Sans\", sans-serif;\n  cursor: pointer;\n  position: fixed;\n  top: 45%;\n  z-index: 99999990;\n  height: 35px !important;\n  min-height: 35px !important;\n  max-height: 35px !important;\n  width: 125px !important;\n  max-width: 125px !important;\n  min-width: 125px !important;\n  -ms-transform: rotate(90deg);\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.kampyle_vertical_button .kampyle_button {\n  height: 35px;\n  min-height: 35px !important;\n  max-height: 35px !important;\n  width: 125px !important;\n  min-width: 125px !important;\n  max-width: 125px !important;\n  background: #c0c0c0;\n  color: #000000;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n.kampyle_vertical_button .kampyle_button-text {\n  color: #000000;\n  font-size: 14px;\n  line-height: 35px;\n  text-align: center;\n  font-weight: normal !important;\n}\n.kampyle_vertical_button.kampyle_left .kampyle_button {\n  -webkit-border-radius: 3px 3px 0 0;\n  -moz-border-radius: 3px 3px 0 0;\n  -ms-border-radius: 3px 3px 0 0;\n  border-radius: 3px 3px 0 0;\n}\n.kampyle_vertical_button.kampyle_right {\n  right: -45px;\n}\n.kampyle_vertical_button.kampyle_left {\n  left: -45px;\n}\n.kampyle_vertical_button.kampyle_right .kampyle_button {\n  -webkit-border-radius: 0 0 3px 3px;\n  -moz-border-radius: 0 0 3px 3px;\n  -ms-border-radius: 0 0 3px 3px;\n  border-radius: 0 0 3px 3px;\n}\n.kampyle_vertical_button.kampyle_right,\n.kampyle_vertical_button.kampyle_left {\n  padding: 0 !important;\n}\n.kampyle_vertical_button:hover .kampyle_button-text {\n  color: #000000;\n}\n.kampyle_vertical_button:hover .kampyle_button {\n  background-color: #c0c0c0;\n}\nbutton#nebula_div_btn {\n  height: auto !important;\n}\n.kampyle_vertical_button {\n  background-color: transparent !important;\n  font-family: \"Open Sans\", sans-serif;\n  cursor: pointer;\n  position: fixed;\n  top: 45%;\n  z-index: 99999990;\n  height: 35px !important;\n  min-height: 35px !important;\n  max-height: 35px !important;\n  width: 125px !important;\n  max-width: 125px !important;\n  min-width: 125px !important;\n  -ms-transform: rotate(90deg);\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.kampyle_vertical_button .kampyle_button {\n  height: 35px;\n  min-height: 35px !important;\n  max-height: 35px !important;\n  width: 125px !important;\n  min-width: 125px !important;\n  max-width: 125px !important;\n  background: #c0c0c0;\n  color: #000000;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n.kampyle_vertical_button .kampyle_button-text {\n  color: #000000;\n  font-size: 14px;\n  line-height: 35px;\n  text-align: center;\n  font-weight: normal !important;\n}\n.kampyle_vertical_button.kampyle_left .kampyle_button {\n  -webkit-border-radius: 3px 3px 0 0;\n  -moz-border-radius: 3px 3px 0 0;\n  -ms-border-radius: 3px 3px 0 0;\n  border-radius: 3px 3px 0 0;\n}\n.kampyle_vertical_button.kampyle_right {\n  right: -45px;\n}\n.kampyle_vertical_button.kampyle_left {\n  left: -45px;\n}\n.kampyle_vertical_button.kampyle_right .kampyle_button {\n  -webkit-border-radius: 0 0 3px 3px;\n  -moz-border-radius: 0 0 3px 3px;\n  -ms-border-radius: 0 0 3px 3px;\n  border-radius: 0 0 3px 3px;\n}\n.kampyle_vertical_button.kampyle_right,\n.kampyle_vertical_button.kampyle_left {\n  padding: 0 !important;\n}\n.kampyle_vertical_button:hover .kampyle_button-text {\n  color: #000000;\n}\n.kampyle_vertical_button:hover .kampyle_button {\n  background-color: #c0c0c0;\n}\nbutton#nebula_div_btn {\n  height: auto !important;\n}\n.kampyle_vertical_button {\n  background-color: transparent !important;\n  font-family: \"Open Sans\", sans-serif;\n  cursor: pointer;\n  position: fixed;\n  top: 45%;\n  z-index: 99999990;\n  height: 35px !important;\n  min-height: 35px !important;\n  max-height: 35px !important;\n  width: 125px !important;\n  max-width: 125px !important;\n  min-width: 125px !important;\n  -ms-transform: rotate(90deg);\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.kampyle_vertical_button .kampyle_button {\n  height: 35px;\n  min-height: 35px !important;\n  max-height: 35px !important;\n  width: 125px !important;\n  min-width: 125px !important;\n  max-width: 125px !important;\n  background: #c0c0c0;\n  color: #000000;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n.kampyle_vertical_button .kampyle_button-text {\n  color: #000000;\n  font-size: 14px;\n  line-height: 35px;\n  text-align: center;\n  font-weight: normal !important;\n}\n.kampyle_vertical_button.kampyle_left .kampyle_button {\n  -webkit-border-radius: 3px 3px 0 0;\n  -moz-border-radius: 3px 3px 0 0;\n  -ms-border-radius: 3px 3px 0 0;\n  border-radius: 3px 3px 0 0;\n}\n.kampyle_vertical_button.kampyle_right {\n  right: -45px;\n}\n.kampyle_vertical_button.kampyle_left {\n  left: -45px;\n}\n.kampyle_vertical_button.kampyle_right .kampyle_button {\n  -webkit-border-radius: 0 0 3px 3px;\n  -moz-border-radius: 0 0 3px 3px;\n  -ms-border-radius: 0 0 3px 3px;\n  border-radius: 0 0 3px 3px;\n}\n.kampyle_vertical_button.kampyle_right,\n.kampyle_vertical_button.kampyle_left {\n  padding: 0 !important;\n}\n.kampyle_vertical_button:hover .kampyle_button-text {\n  color: #000000;\n}\n.kampyle_vertical_button:hover .kampyle_button {\n  background-color: #c0c0c0;\n}\nbutton#nebula_div_btn {\n  height: auto !important;\n}\n.kampyle_vertical_button {\n  background-color: transparent !important;\n  font-family: \"Open Sans\", sans-serif;\n  cursor: pointer;\n  position: fixed;\n  top: 45%;\n  z-index: 99999990;\n  height: 35px !important;\n  min-height: 35px !important;\n  max-height: 35px !important;\n  width: 125px !important;\n  max-width: 125px !important;\n  min-width: 125px !important;\n  -ms-transform: rotate(90deg);\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.kampyle_vertical_button .kampyle_button {\n  height: 35px;\n  min-height: 35px !important;\n  max-height: 35px !important;\n  width: 125px !important;\n  min-width: 125px !important;\n  max-width: 125px !important;\n  background: #c0c0c0;\n  color: #000000;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n.kampyle_vertical_button .kampyle_button-text {\n  color: #000000;\n  font-size: 14px;\n  line-height: 35px;\n  text-align: center;\n  font-weight: normal !important;\n}\n.kampyle_vertical_button.kampyle_left .kampyle_button {\n  -webkit-border-radius: 3px 3px 0 0;\n  -moz-border-radius: 3px 3px 0 0;\n  -ms-border-radius: 3px 3px 0 0;\n  border-radius: 3px 3px 0 0;\n}\n.kampyle_vertical_button.kampyle_right {\n  right: -45px;\n}\n.kampyle_vertical_button.kampyle_left {\n  left: -45px;\n}\n.kampyle_vertical_button.kampyle_right .kampyle_button {\n  -webkit-border-radius: 0 0 3px 3px;\n  -moz-border-radius: 0 0 3px 3px;\n  -ms-border-radius: 0 0 3px 3px;\n  border-radius: 0 0 3px 3px;\n}\n.kampyle_vertical_button.kampyle_right,\n.kampyle_vertical_button.kampyle_left {\n  padding: 0 !important;\n}\n.kampyle_vertical_button:hover .kampyle_button-text {\n  color: #000000;\n}\n.kampyle_vertical_button:hover .kampyle_button {\n  background-color: #c0c0c0;\n}\nbutton#nebula_div_btn {\n  height: auto !important;\n}\n.kampyle_vertical_button {\n  background-color: transparent !important;\n  font-family: \"Open Sans\", sans-serif;\n  cursor: pointer;\n  position: fixed;\n  top: 45%;\n  z-index: 99999990;\n  height: 35px !important;\n  min-height: 35px !important;\n  max-height: 35px !important;\n  width: 125px !important;\n  max-width: 125px !important;\n  min-width: 125px !important;\n  -ms-transform: rotate(90deg);\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.kampyle_vertical_button .kampyle_button {\n  height: 35px;\n  min-height: 35px !important;\n  max-height: 35px !important;\n  width: 125px !important;\n  min-width: 125px !important;\n  max-width: 125px !important;\n  background: #c0c0c0;\n  color: #000000;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n.kampyle_vertical_button .kampyle_button-text {\n  color: #000000;\n  font-size: 14px;\n  line-height: 35px;\n  text-align: center;\n  font-weight: normal !important;\n}\n.kampyle_vertical_button.kampyle_left .kampyle_button {\n  -webkit-border-radius: 3px 3px 0 0;\n  -moz-border-radius: 3px 3px 0 0;\n  -ms-border-radius: 3px 3px 0 0;\n  border-radius: 3px 3px 0 0;\n}\n.kampyle_vertical_button.kampyle_right {\n  right: -45px;\n}\n.kampyle_vertical_button.kampyle_left {\n  left: -45px;\n}\n.kampyle_vertical_button.kampyle_right .kampyle_button {\n  -webkit-border-radius: 0 0 3px 3px;\n  -moz-border-radius: 0 0 3px 3px;\n  -ms-border-radius: 0 0 3px 3px;\n  border-radius: 0 0 3px 3px;\n}\n.kampyle_vertical_button.kampyle_right,\n.kampyle_vertical_button.kampyle_left {\n  padding: 0 !important;\n}\n.kampyle_vertical_button:hover .kampyle_button-text {\n  color: #000000;\n}\n.kampyle_vertical_button:hover .kampyle_button {\n  background-color: #c0c0c0;\n}\nbutton#nebula_div_btn {\n  height: auto !important;\n}\n.kampyle_vertical_button {\n  background-color: transparent !important;\n  font-family: \"Open Sans\", sans-serif;\n  cursor: pointer;\n  position: fixed;\n  top: 45%;\n  z-index: 99999990;\n  height: 35px !important;\n  min-height: 35px !important;\n  max-height: 35px !important;\n  width: 125px !important;\n  max-width: 125px !important;\n  min-width: 125px !important;\n  -ms-transform: rotate(90deg);\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.kampyle_vertical_button .kampyle_button {\n  height: 35px;\n  min-height: 35px !important;\n  max-height: 35px !important;\n  width: 125px !important;\n  min-width: 125px !important;\n  max-width: 125px !important;\n  background: #c0c0c0;\n  color: #000000;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n.kampyle_vertical_button .kampyle_button-text {\n  color: #000000;\n  font-size: 14px;\n  line-height: 35px;\n  text-align: center;\n  font-weight: normal !important;\n}\n.kampyle_vertical_button.kampyle_left .kampyle_button {\n  -webkit-border-radius: 3px 3px 0 0;\n  -moz-border-radius: 3px 3px 0 0;\n  -ms-border-radius: 3px 3px 0 0;\n  border-radius: 3px 3px 0 0;\n}\n.kampyle_vertical_button.kampyle_right {\n  right: -45px;\n}\n.kampyle_vertical_button.kampyle_left {\n  left: -45px;\n}\n.kampyle_vertical_button.kampyle_right .kampyle_button {\n  -webkit-border-radius: 0 0 3px 3px;\n  -moz-border-radius: 0 0 3px 3px;\n  -ms-border-radius: 0 0 3px 3px;\n  border-radius: 0 0 3px 3px;\n}\n.kampyle_vertical_button.kampyle_right,\n.kampyle_vertical_button.kampyle_left {\n  padding: 0 !important;\n}\n.kampyle_vertical_button:hover .kampyle_button-text {\n  color: #000000;\n}\n.kampyle_vertical_button:hover .kampyle_button {\n  background-color: #c0c0c0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
